

































































import { Vue, Component, Prop } from "vue-property-decorator";
import { IMenuRoute } from "@/models/routes";
import _ from "@/boot/lodash";

@Component
export default class UDropdownMenu extends Vue {
  // Props

  @Prop({ required: true })
  public routes!: IMenuRoute[];

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: false })
  public isProcessing!: boolean;

  // Computed

  public get availableRoutes() {
    const vm = this as UDropdownMenu;
    return _.map(
      _.filter(this.routes, r => (r.if ?? (() => true))(vm)),
      r => ({ ...r, to: _.isFunction(r.to) ? r.to(this) : r.to })
    );
  }

  public get activeRoute() {
    return _.find(
      this.availableRoutes,
      ({ to }) => to.name === this.$route.name
    );
  }

  public get ctaLabel() {
    return this.activeRoute?.activeLabel || this.activeRoute?.label;
  }

  public get activeRouteLabel() {
    return this.activeRoute?.label;
  }
}
